import React from 'react'

const YoutubeSVG = (props) => (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 86.16 83.04" {...props}>
        <rect x="2.45" y="15.98" width="83.71" height="57.9" rx="16.3" ry="16.3"/>
        <rect x="2.4" y="11.41" width="77.1" height="53.33" rx="16.3" ry="16.3" fill="#fff" stroke="#000" strokeMiterlimit="10" strokeWidth="6"/>
        <path fill='#000' d="M30.62,25.32v25.5c0,1.69,1.88,2.71,3.29,1.78l19.56-12.75c1.29-.84,1.29-2.73,0-3.57l-19.56-12.75c-1.42-.92-3.29.09-3.29,1.78Z"/>
    </svg>
)

export default YoutubeSVG
